export default __webpack_public_path__ + "static/media/737.72229144.png";